import { render } from "./OcrFolderPanel.vue?vue&type=template&id=5de74fd8"
import script from "./OcrFolderPanel.vue?vue&type=script&lang=js"
export * from "./OcrFolderPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__